// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { motion, useAnimation } from 'framer-motion';
import { Box, Image, Divider, Button, Grid, Text, Flex, Skeleton, useBreakpointValue, useColorModeValue } from '@chakra-ui/react';
import { NavLink, Link, useHistory, useLocation } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import { ReactComponent as PlusCategoryIcon } from 'assets/svg/show-category-parent.svg';

// Components
import { ArrowCategoryIcon } from 'components/Icons/Icons';

const Categories = ({selectedCategory, setCategoryId}) => {
	const textColor = useColorModeValue('#0E1633', 'white');
    const textSubColor = useColorModeValue('#262D47', '#9FABCB');
    const borderBottom = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');

    const { data, isLoading } = useQuery({
        queryKey: ['categoriesWithParent'],
        queryFn: async () => {
            const response = await apiService.getCategories({ limit: 250, offset: 0, featured: true });
            return response.data;
        },
        refetchOnWindowFocus: false
    });

    const [collapsedItem, setCollapsedItem] = useState({}); 
    const toggleItem = (rowId) => {
        setCollapsedItem((prev) => ({
          ...prev,
          [rowId]: !prev[rowId],
        }));
    };

    const [collapsedItems, setCollapsedItems] = useState(false); 
    const toggleItems = () => {
        setCollapsedItems(!collapsedItems);
    };

    const responsiveSettings = useBreakpointValue({ base: true, md: false });
    useEffect(() => { setCollapsedItems(responsiveSettings); }, [responsiveSettings]);

    const history = useHistory();
    const addParams = (id) => {
        const searchParams = new URLSearchParams(window.location.search);

        const currentCategory = searchParams.get('category');        
        if(parseInt(currentCategory) === id){
            searchParams.delete('category');    
            setCategoryId(null);
        } else {
            searchParams.set('category', id);     
        }
            
        history.push({ search: searchParams.toString() }); 
    };

    useEffect(() => {
        if(!isLoading){
            const updatedCollapsedItems = { ...collapsedItem };
            data?.forEach(item => {
                if (item.subCategories?.some(subItem => parseInt(selectedCategory) === subItem?.id)) {
                    updatedCollapsedItems[item.id] = true; 
                }
            });

            setCollapsedItem(updatedCollapsedItems);
        }
    }, [selectedCategory, data]);

    return (
    	<>
    	{ isLoading ? ( 
            <Skeleton height="40px" my="8px" borderRadius="16px" />
        ) : (
            <>
                <Flex alignItems="center" justifyContent="space-between" pt="10px">
                    <Text variant="text-md" color={textColor} fontWeight="500">
                        Category
                    </Text>
                    <ArrowCategoryIcon 
                        fontSize="24px"
                        transition="0.2s all"
                        transform={ collapsedItems ? 'rotate(90deg)' : 'rotate(0deg)' } 
                        onClick={toggleItems} />
                </Flex>
            
                <Box 
                    maxH={ collapsedItems ? '0px' : '450px' } 
                    transition="0.2s all" 
                    overflowX="hidden" 
                    overflowY={ collapsedItems ? 'hidden' : 'scroll'}
                    opacity={ collapsedItems ? '0' : '1'}
                    p="24px 12px 0 12px"
                    sx={{
                        '&::-webkit-scrollbar': { display: 'none' }, 
                        '-ms-overflow-style': 'none', 
                        'scrollbar-width': 'none',
                    }}
                    >
                    { data?.map((item, index) => (
                        <Flex key={index} w="100%" gap="12px" mb="17px" alignItems="start">
                            {/*<Box mt="-2px">
                                <PlusCategoryIcon
                                    w="22px"
                                    h="22px"
                                    color="white"
                                    opacity={item?.subCategories?.length > 0 ? '1' : '0.4'}
                                    cursor="pointer"
                                    onClick={() => toggleItem(item.id)} />
                            </Box>*/}

                            <Box w="100%">
                                <Text 
                                    variant="text-sm" 
                                    color={ parseInt(selectedCategory) === item?.id ? '#0698fd' : textColor}
                                    width="max-content"
                                    lineHeight="30px"
                                    mt="-7px"
                                    w="90%"
                                    cursor="pointer"
                                    onClick={() => addParams(item?.id)}
                                    borderBottom={ collapsedItem[item.id] ? '1px solid #0698fd' : '1px solid transparent' }
                                    fontWeight="500">
                                    {item.name} 
                                </Text>

                                { item.subCategories && (
                                  <Box
                                    w="100%"
                                    display={collapsedItem[item.id] ? 'block' : 'none'}>
                                    { item.subCategories.map((subItem, subIndex) => (
                                        <Text
                                            key={subItem?.id} 
                                            variant="text-sm"
                                            cursor="pointer"
                                            color={ parseInt(selectedCategory) === subItem?.id ? '#0698fd' : textSubColor}
                                            mt="15px"
                                            w="90%"
                                            onClick={() => addParams(subItem?.id)}
                                            mb={ (subIndex + 1) === item.subCategories.length ? '0px' : '23px'}
                                            fontWeight="500"
                                        >
                                            {subItem?.name}
                                        </Text>
                                    ))}
                                  </Box>
                                )}
                            </Box>
                        </Flex>
                    ))}
                </Box>

                <Box borderTop={borderBottom} opacity={collapsedItems ? '0' : '1'} />
            </>
	    )}
	    </>
    );
};


export default Categories;